import { Component, OnInit } from '@angular/core';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { StripePyout, StripePyoutForm } from '../model/model.class';
import { FormGroup, FormBuilder } from '@angular/forms';
import { StripePayoutsService } from '../profile.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-payoutaccount',
  templateUrl: './payoutaccount.component.html',
  styleUrls: ['./payoutaccount.component.css']
})
export class PayoutaccountComponent extends AppComponentClass<StripePyout, StripePyoutForm> {
  
  key: number;
  form : FormGroup;
  submitted: boolean= false;
  public state:boolean=false;
  constructor(protected data: StripePayoutsService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb , msg);     
    this.key = parseInt(sessionStorage.getItem('iduser'));         
  }

  ngOnInit(): void {     
     
      this.data.getService().subscribe(res=>{
        if(res != null)  
        {
          this.keyfield=res[0].id;         
          this.cdata=new StripePyoutForm(res[0]);  
          this.form=this.cdata.makeform(this.fb);
        }  
        else
        {
          this.keyfield=-1;         
          this.cdata=new StripePyoutForm(null);  
          this.form=this.cdata.makeform(this.fb);
        }
        this.state=true;
      },
      err =>{
        this.keyfield=-1;
        this.cdata=new StripePyoutForm(null);   
        this.form=this.cdata.makeform(this.fb);
        this.state=true;
      }); 
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }
  
  onSubmit()
  {
    this.submitted = true;
    if (this.form.invalid) {
        return;
    }
    if(this.cdata.saveForm(this.form))
    {      
      console.log(this.cdata);
      if(this.keyfield==-1)
      {
        this.data.CreatePauoutAccount(JSON.stringify(this.cdata)).subscribe( rs =>  {       
          this.openSnackBar(rs.msg,"Clear");         
          this.data.getService().subscribe(rss=>{
            console.log(rss);
            this.keyfield = rss[0].id;
          });
        });
      }
      else
      {
        this.data.UpdatePauoutAccount(JSON.stringify(this.cdata)).subscribe( rs => 
        {          
          this.openSnackBar(rs.msg,"Clear");         
        }); 
      } 
    }  
  }

  onReset()
  {
    this.data.DeletePauoutAccount(this.keyfield).subscribe(res =>{
      this.openSnackBar(res.msg,"Clear");
      this.keyfield=-1;
      this.cdata=new StripePyoutForm(null);   
      this.form=this.cdata.makeform(this.fb);  
    });
  }

}
